export default "__VITE_ASSET__Cvq1GCvU__"